export class FileUpload
{
    static cropper;
    static cropperDestroy;
    static PicToUpload;
    static BlobFile;
    static filename;
    static filenameClass;
    static uploadType;
    static buttonsContainer;
    static image;
    static passportPicturePicToUpload;
    static passportPictureBlobFile;
    static idCardPicToUpload;
    static idCardBlobFile;
    static signaturePicToUpload;
    static signatureBlobFile;

    constructor(fileInput = null)
    {
        this.fileInput = fileInput;
        this.cropButton = $('.crop');
        this.resetButton = $('.reset-crop');
        this.cancelButton = $('.cancel-crop');
        this.uploadButton = $('.upload-crop');
        this.uploadSign = $('.upload-sign');
        this.$progress = $('.progress');
        this.cropper;
        this.cropperStarted = false;
        this.cropperDestroy;
        this.picToUpload, this.blobFile, this.filename;
        this.imageUrl = 'resources/images/placeholder-image.png';
        this.filenameClass;
        this.uploadType;
        this.buttonsContainer;
        this.image;
        this.passportPicturePicToUpload;
        this.passportPictureBlobFile;
        this.idCardPicToUpload;
        this.idCardBlobFile;
        this.signaturePicToUpload;
        this.signatureBlobFile;
    }

    onChange()
    {
        this.uploadType = this.fileInput.attr('data-upload-type');
        this.filename = this.fileInput[0].files[0].name;

        this.filenameClass = '.filename.' + this.uploadType;
        let file;
        let input;
        let initialImageURL;


        $('.file-input-btn').html('Change Photo');
        input = this.fileInput;

        if (this.uploadType === 'delegate-picture') {
            this.image = document.getElementById('delegate-picture-image');
            this.buttonsContainer = $('.delegate-picture-buttons-container');
            this.imageUrl = '/resources/images/placeholder-image.png';
        }

        if (this.uploadType === 'signature') {
            this.image = document.getElementById('signature-image');
            this.buttonsContainer = $('.signature-buttons-container');
            this.imageUrl = '/resources/images/placeholder-image.png';
        }

        $(this.filenameClass).html(this.filename);

        initialImageURL = this.image.src;

        let files = this.fileInput[0].files;
        file = files[0];

        this.buttonsContainer.find(this.cropButton).show();
        this.buttonsContainer.find(this.resetButton).show();
        // buttonsContainer.find(cancelButton).show();
        // uploadButton.show();

        if (!this.cropper) {
            this.cropperStarted = true;
            $(this.image).attr('src', window.URL.createObjectURL(file));
            if (this.uploadType === 'id-card' || this.uploadType === 'signature') {
                this.cropper = new Cropper(this.image, {
                    aspectRatio: 2,
                    viewMode: 2,
                    autoCropArea: 1,
                    minContainerHeight: 250,
                });
            } else {
                this.cropper = new Cropper(this.image, {
                    aspectRatio: 1,
                    viewMode: 2,
                    autoCropArea: 1,
                    minContainerHeight: 250,
                });
            }
        } else {
            this.cropperStarted = true;
            $(this.image).attr('src', window.URL.createObjectURL(file));
            this.cropper.replace(window.URL.createObjectURL(file));
        }
        this.cropperDestroy = this.cropper;
        $(window).resize();

        return {
            'cropper': this.cropper,
            'cropperDestroy': this.cropperDestroy,
            'picToUpload': this.picToUpload,
            'blobFile': this.blobFile,
            'filename': this.filename,
            'imageUrl': this.imageUrl,
            'filenameClass': this.filenameClass,
            'uploadType': this.uploadType,
            'buttonsContainer': this.buttonsContainer,
            'image': this.image,
            'passportPicturePicToUpload': this.passportPicturePicToUpload,
            'passportPictureBlobFile': this.passportPictureBlobFile,
            'idCardPicToUpload': this.idCardPicToUpload,
            'idCardBlobFile': this.idCardBlobFile,
            'signaturePicToUpload': this.signaturePicToUpload,
            'signatureBlobFile': this.signatureBlobFile,
        };
    }

    onCancelCrop(cropper)
    {
        $(document).on('click', '.cancel-crop', function() {
            $(filenameClass).html('No File Chosen');
            cropper.destroy();
            cropper = '';

            if (uploadType === 'passport-picture') {
                imageUrl = baseUrl + 'assets/img/placeholder.jpg';
            }

            if (uploadType === 'id-card') {
                imageUrl = baseUrl + 'assets/img/id_card_placeholder.png';
            }

            if (uploadType === 'signature') {
                imageUrl = baseUrl + 'assets/img/signature_placeholder.png';
            }

            image.removeAttribute('src');
            image.src = imageUrl;
            // $('#image').hide();
            buttonsContainer.find(cropButton).hide();
            buttonsContainer.find(resetButton).hide();
            buttonsContainer.find(cancelButton).hide();
            buttonsContainer.find(uploadButton).hide();
            buttonsContainer.find(uploadSign).hide();
            PicToUpload = undefined;

            var target = $(this).data('target');
            var name = $('#' + target).attr('name');
            var id = $('#' + target).attr('id');
            refresh_file_input($('#' + target), $('.buttons-container'), name, id, uploadType);

            // refresh_file_input($('#picture-upload'), $('.buttons-container'));
            /*$('#video-frame').slideDown(400)
            $('.btn-camera-flip, .btn-camera-capture').addClass('hide');*/
            // $(window).resize();
        });
    }

    onResetCrop(cropper)
    {
        cropper.reset();
    }

    onCrop(cropperData)
    {
        // let uploadType = $(this).data('upload-type');
        let initialImageURL;
        let canvas;

        if (cropperData.cropper) {
            canvas = cropperData.cropper.getCroppedCanvas({
                width: 250,
                height: 250,
            });

            initialImageURL = cropperData.image.src;
            cropperData.image.src = canvas.toDataURL();
            $(cropperData.image).attr('src', canvas.toDataURL('image/jpeg'));
            cropperData.imageUrl = $(cropperData.image).attr('src');
            $('.btn-camera-flip, .btn-camera-capture').addClass('hide');
            $('.image-preview').fadeIn(400).css('display', 'block');
            cropperData.buttonsContainer.find(cropperData.cropButton).hide();
            cropperData.buttonsContainer.find(cropperData.resetButton).hide();
            cropperData.buttonsContainer.find(cropperData.uploadButton).show();
            cropperData.buttonsContainer.find(cropperData.uploadSign).show();
            cropperData.cropperDestroy.destroy();
            cropperData.cropper = '';
            // $(window).resize();

            let file_ext = cropperData.filename.split('.').last();
            if (cropperData.uploadType === 'delegate-picture') {
                if (file_ext.toLowerCase() === 'jpg' || file_ext.toLowerCase() === 'jpeg') {
                    canvas.toBlob(function(blob) {
                        cropperData.passportPicturePicToUpload = blob;
                        cropperData.passportPictureBlobFile = new File([cropperData.passportPicturePicToUpload], cropperData.filename, {
                            type: 'image/jpeg'});
                    }, 'image/jpeg');
                } else {
                    if (file_ext.toLowerCase() === 'png') {
                        canvas.toBlob(function(blob) {
                            cropperData.passportPicturePicToUpload = blob;
                            cropperData.passportPictureBlobFile = new File([cropperData.passportPicturePicToUpload], cropperData.filename, {type: 'image/png'});
                        }, 'image/png');
                    } else {
                        if (file_ext.toLowerCase() === 'webp') {
                            canvas.toBlob(function(blob) {
                                cropperData.passportPicturePicToUpload = blob;
                                cropperData.passportPictureBlobFile = new File([cropperData.passportPicturePicToUpload], cropperData.filename, {type: 'image/webp'});
                            }, 'image/webp');
                        }
                    }
                }
            }

            if (cropperData.uploadType === 'signature') {
                if (file_ext.toLowerCase() === 'jpg' || file_ext.toLowerCase() === 'jpeg') {
                    canvas.toBlob(function(blob) {
                        cropperData.signaturePicToUpload = blob;
                        cropperData.signatureBlobFile = new File([cropperData.signaturePicToUpload], cropperData.filename, {type: 'image/jpeg'});
                    }, 'image/jpeg');
                } else {
                    if (file_ext.toLowerCase() === 'png') {
                        canvas.toBlob(function(blob) {
                            cropperData.signaturePicToUpload = blob;
                            cropperData.signatureBlobFile = new File([cropperData.signaturePicToUpload], cropperData.filename, {type: 'image/png'});
                        }, 'image/png');
                    } else {
                        if (file_ext.toLowerCase() === 'webp') {
                            canvas.toBlob(function(blob) {
                                cropperData.signaturePicToUpload = blob;
                                cropperData.signatureBlobFile = new File([cropperData.signaturePicToUpload], cropperData.filename, {type: 'image/webp'});
                            }, 'image/webp');
                        }
                    }
                }
            }
        }

        return cropperData;
    }
}
